import React, { useState } from 'react';
import { TextField, Button, Alert, Box, Typography ,CircularProgress} from '@mui/material';
import { confirmPasswordReset } from "firebase/auth";
import firebaseAuthRef from "../firebase_auth"


interface ResetPasswordFormProps {
  token: string;
  email: String;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ token, email}) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true)
    confirmPasswordReset(firebaseAuthRef, token, password).then((resp) => {
      setSuccess('Password reset successfully')
      setError('')
      setLoading(false)
    }).catch((error) => {
      setError(error.message)
      setSuccess('')
      setLoading(false)
    });
    
  };

  return (
              <form onSubmit={handleSubmit}>
              <Typography>for <strong>{email}</strong></Typography>
            <TextField
              label="New Password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              margin="normal"
              fullWidth
              required
            />
            <TextField
              label="Confirm New Password"
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              margin="normal"
              fullWidth
              required
            />
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">Password reset successfully!</Alert>}
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2 }}
              >
                Reset Password
              </Button>
                      {loading && (
          <CircularProgress
            size={24}
            color = "secondary"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
            }}
          />
        )}
            </Box>
          </form>
  );
};

export default ResetPasswordForm;